import { render, staticRenderFns } from "./elements.vue?vue&type=template&id=410e24de&scoped=true&lang=pug"
import script from "./elements.vue?vue&type=script&lang=js"
export * from "./elements.vue?vue&type=script&lang=js"
import style0 from "./elements.vue?vue&type=style&index=0&id=410e24de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410e24de",
  null
  
)

export default component.exports